import { render, staticRenderFns } from "./AttentionIndex.vue?vue&type=template&id=1e411f28&scoped=true"
import script from "./AttentionIndex.vue?vue&type=script&lang=js"
export * from "./AttentionIndex.vue?vue&type=script&lang=js"
import style0 from "./AttentionIndex.vue?vue&type=style&index=0&id=1e411f28&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e411f28",
  null
  
)

export default component.exports